module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/WILD@1x.png?1.0.17";